/**
 * Screenshots of the product, and what each one shows.
 *
 * GENERATED by scripts/screenshots.mjs — do not edit by hand. The pictures it
 * describes are real captures of the real app, taken by driving a browser
 * against the real backend; see that file for why they are not drawn.
 *
 * Regenerate with:  npm run build && npm run screenshots
 */
export type Theme = 'light' | 'dark';

export interface Screen {
  /** Also the filename: /screens/<id>.png for the default palette */
  id: string;
  title: string;
  caption: string;
  shape: 'desktop' | 'phone';
  /** CSS pixels the shot was taken at, so the page reserves the right box. */
  width: number;
  height: number;
  /** Which palettes were actually captured for this screen. */
  themes: Theme[];
}

/** The palette the app opens in, and the one the bare filename holds. */
export const DEFAULT_THEME: Theme = 'light';

export const SCREENS: Screen[] = [
  {
    "id": "dashboard",
    "title": "Everything at a glance",
    "caption": "Occupancy, what is owed, what is waiting on you, and how collection has gone month by month.",
    "shape": "desktop",
    "width": 1360,
    "height": 900,
    "themes": [
      "light",
      "dark"
    ]
  },
  {
    "id": "payments",
    "title": "Rent verified, not assumed",
    "caption": "A tenant submits a payment with proof. It counts for nothing against their balance until a manager confirms it.",
    "shape": "desktop",
    "width": 1360,
    "height": 900,
    "themes": [
      "light",
      "dark"
    ]
  },
  {
    "id": "messages",
    "title": "Texting a tenant",
    "caption": "Pick a template, see the exact words and the segment count, and send it yourself. Nothing here goes out on a timer.",
    "shape": "desktop",
    "width": 1360,
    "height": 900,
    "themes": [
      "light",
      "dark"
    ]
  },
  {
    "id": "sms",
    "title": "Sending a text",
    "caption": "Choose the channel per message — their account, a text or an email — and see the number and the segment count before you press send.",
    "shape": "desktop",
    "width": 1360,
    "height": 900,
    "themes": [
      "light",
      "dark"
    ]
  },
  {
    "id": "reminders",
    "title": "Who needs chasing",
    "caption": "Worked out when you open it — overdue, ending, unprotected deposits — and it never sends anything on its own.",
    "shape": "desktop",
    "width": 1360,
    "height": 900,
    "themes": [
      "light",
      "dark"
    ]
  },
  {
    "id": "tenants",
    "title": "Every tenant, and what they owe",
    "caption": "Contact details, tenancy, documents and a full payment history, with the balance computed from confirmed payments only.",
    "shape": "desktop",
    "width": 1360,
    "height": 900,
    "themes": [
      "light",
      "dark"
    ]
  },
  {
    "id": "properties",
    "title": "Properties and rooms",
    "caption": "Let per room or as a whole. Occupancy is derived from tenancies, so a room cannot be marked occupied with nobody in it.",
    "shape": "desktop",
    "width": 1360,
    "height": 900,
    "themes": [
      "light",
      "dark"
    ]
  },
  {
    "id": "portal",
    "title": "What the tenant sees",
    "caption": "Their balance, what is due and when, their documents and a way to message you — signed in with their phone, no password.",
    "shape": "phone",
    "width": 420,
    "height": 880,
    "themes": [
      "light",
      "dark"
    ]
  },
  {
    "id": "portal-pay",
    "title": "Paying, with proof",
    "caption": "The tenant submits what they paid and a photo of the receipt. You confirm it at your end.",
    "shape": "phone",
    "width": 420,
    "height": 880,
    "themes": [
      "light",
      "dark"
    ]
  }
];

/**
 * Where a screenshot lives.
 *
 * The default palette keeps the bare filename and the other is suffixed, so
 * "the screenshot" is always the representative one however the default is set.
 */
export const screenUrl = (id: string, theme: Theme = DEFAULT_THEME) =>
  theme === DEFAULT_THEME ? `/screens/${id}.png` : `/screens/${id}-${theme}.png`;
